// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ForecastsUpdatePayloadSchema = z.object({
  user_id: z.optional(z.number().int().describe("Change who will work on this task")),
  project_id: z.optional(z.number().int().describe("Move task to a different project")),
  hours: z.optional(z.number().int().min(0).describe("Update task hours")),
  minutes: z.optional(z.number().int().min(0).max(59).describe("Update tasked minutes")),
  day: z.optional(z.coerce.string().describe("Move task to different date (YYYY-MM-DD)")),
  note: z.coerce.string().describe("Update task description").nullish(),
});
